<script>
import CardBridgeUpload from './card-bridge-upload'
import ValidateMixin from './mixins/validate'

export default {
  name: 'RnrIdcard',
  components: { CardBridgeUpload },
  mixins: [ValidateMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => ([])
    },
    attrs: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    compress: {
      type: Object,
      default: null
    },
    api: {
      type: Function,
      default: () => {}
    },
    validateCallback: {
      type: Function,
      default: null
    },
    itype: {
      type: String,
      default: '1'
    }
  },
  computed: {
    cardType() {
      var result
      switch (this.itype) {
        case 'HKIDCARD':
        // 港澳居民来往内地通行证
          result = 3
          break
        case 'PASSPORT':
        // 护照
          result = 5
          break
        case 'PLAIDCARD':
        // 军官证
          result = 7
          break
        case 'POLICEPAPER':
        // 警官证
          result = 9
          break
        case 'TAIBAOZHENG':
        // 台湾居民来往大陆通行证
          result = 11
          break
        case 'HKRESIDENCECARD':
        // 港澳居民居住证
          result = 13
          break
        case 'TWRESIDENCECARD':
        // 台湾居民居住证
          result = 15
          break
        case 'HOUSEHOLD':
        // 户口簿
          result = 17
          break
        case 'OTHER':
        // 其他证件
          result = 19
          break
      }
      console.log('result', this.itype, result)
      return result
    }
  },
  methods: {
    /**
     * 当图片发生改变的方法
     */
    handleImageChange(index, val) {
      // 重新赋值
      const value = [...this.value]
      value[index] = val[0]
      // 开始双向绑定
      this.$emit('input', value)
      // 触发改变方法
      this.$emit('change', value)
      // 等界面渲染完成后
      this.$nextTick(this.validate)
    }
  },
  render() {
    return (
      <div class='rnr-idcard'>
        <div class='idcard-image-wrapper'>
          <card-bridge-upload iType={this.cardType} size='large' compress={this.compress} value={this.value[0] ? [this.value[0]] : []} api={this.api} maxCount={1} onInput={val => this.handleImageChange(0, val)}>
            <div class='upload-wrapper othercard-front'>
              <div class='icon-upload-camera' />
            </div>
          </card-bridge-upload>
          <div class='idcard-label'>请上传证件信息正面</div>
        </div>
        <div class='idcard-image-wrapper'>
          <card-bridge-upload iType={this.cardType + 1} size='large' compress={this.compress} value={this.value[1] ? [this.value[1]] : []} api={this.api} maxCount={1} onInput={val => this.handleImageChange(1, val)}>
            <div class='upload-wrapper othercard-back'>
              <div class='icon-upload-camera' />
            </div>
          </card-bridge-upload>
          <div class='idcard-label'>请上传证件信息反面</div>
        </div>
      </div>
    )
  }
}
</script>
<style lang="scss">
.rnr-idcard {
  .idcard-image-wrapper {
    margin-top: 64px;
    .component-bridge-upload {
      display: flex;
      justify-content: center;
      .upload-wrapper {
        background-color: #F7F8FA;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
        width: 516px;
        height: 322px;
        position: relative;

        .icon-upload-camera {
          background-image: url(./assets/ico_camera.png);
          background-size: 100% 100%;
          position: absolute;
          width: 80px;
          height: 80px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        &.othercard-front {
          background-image: url(./assets/ico_pic_large.png);
        }
        &.othercard-back {
          background-image: url(./assets/ico_pic_large.png);
        }
      }
      .van-uploader__input-wrapper {
        margin: 0 auto;
      }
      .van-uploader__preview {
        width: 516px;
        height: 322px;
        margin: 0 auto !important;
        overflow: hidden;
        .van-uploader__preview-image {
          width: 100% !important;
          height: 100% !important;
        }
        .van-uploader__preview-delete {
          background-color: rgba(0, 0, 0, .4);
          border-radius: 20px;
          display: flex;
          width: 40px;
          height: 40px;
          .van-uploader__preview-delete-icon {
            font-size: 60px;
            top: -10px;
            right: -10px;
          }
        }
        &:nth-child(3) {
          margin-right: 0px;
        }
      }
    }
    .idcard-label {
      color: rgba(36, 36, 36, 0.4);
      font-size: 24px;
      font-weight: 400;
      line-height: 33px;
      margin-top: 16px;
      text-align: center;
    }
    &:first-child {
      margin-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FormRender/othercard.vue